import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AnimateHeight from 'react-animate-height';
import { connect } from 'react-redux'
import { selectItem, toggleMenu } from '../../actions'
import Share from '../share/share'
import './menu.critical.css'
import { sendEvent } from '../../helpers/analytics'

class Menu extends Component {
  constructor(props) {
    super(props)

    this.state = {
      menuY: 0,
      y: 0,
      hoverY: false,
      x: 0,
      height: 0,
      hoverHeight: false,
      markerIsVisible: false,
      isMobile: document.body.clientWidth < 1024,
      interval: null
    }

    this.menuRefs = []

    this.items = [
      {title: 'о проекте', id: 0},
      {
        title: '70 лет спортивным автомобилям',
        id: 1,
        id2: 2,
        sub: [
          {title: 'начало пути', id: 3},
          {title: 'Первое покорение Ле-Мана', id: 4},
          {title: 'Теперь и Формула-1!', id: 5},
          {title: 'Возвращение на вершину', id: 6},
          {title: 'Вы тоже гонщик!', id: 7},
          {title: 'ещё ближе к Porsche!', id: 8},
        ]
      },
      {
        title: 'Гоночный сезон 2018', id: 9,
        sub: [
          {title: 'Светлана Горбунова', id: 9},
          {title: 'Олег Кесельман', id: 10},
          {title: 'Moscow Raceway', id: 11}
        ]
      },
      {title: 'Конкурс на скоростях', id: 12},
      {title: 'PORSCHE инфографика', id: 13}
    ]

  }

  menuRef = (node) => {this.menu = node}

  componentDidMount () {
    window.addEventListener('resize', this.checkIfMobile);
    setTimeout(() => {
      this.updateMarker(this.props.currentItem)
      this.setState({markerIsVisible: true})
    }, 100)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.checkIfMobile);
  }

  checkIfMobile = () => {
    this.setState({isMobile: document.body.clientWidth < 1024})
  }

  itemClickHandler = (id, title, link) => {
    // if (link !== this.props.location.pathname) {
    //   this.props.history.push(link)
    // }
    this.props.onMenuClick(id)
    if (this.props.isOpen) this.props.onMenuToggle()

    if (id === 13) {
      sendEvent('main', 'click', 'infographic')
    } else {
      sendEvent('main', 'click', title)
    }
  }

  itemMouseoverHandler = (id) => {
    let hoverEl = this.menuRefs[id]
    let hoverY = hoverEl.getBoundingClientRect().y
    let hoverHeight = hoverEl.getBoundingClientRect().height
    let menuY = this.menu.getBoundingClientRect().y
    this.setState({hoverY, hoverHeight, menuY})
  }

  itemMouseOutHandler = () => {
    let menuY = this.menu.getBoundingClientRect().y
    this.setState({hoverY: false, hoverHeight: false, menuY})
    this.updateMarker(this.props.currentItem)
  }

  renderMenuList = (items) => {
    return items.map((item) => {
      let itemClass = item.id === this.props.currentItem || item.id2 === this.props.currentItem  ? 'menu__item --active' : 'menu__item'
      let ifSubActive = item.sub ? item.sub.some((subitem) => subitem.id === this.props.currentItem) : false
      // let height = item.id === this.props.currentItem || item.id2 === this.props.currentItem || ifSubActive ? 'auto' : 0
      let height = item.id === this.props.currentItem || item.id2 === this.props.currentItem || ifSubActive ? 'auto' : 0

      if (ifSubActive) {
        itemClass += ' --active-parent'
      }

      return (
        <li key={item.id} className={itemClass}
            onMouseLeave={() => this.itemMouseOutHandler() }
        >
          <span ref={(node) => {this.menuRefs[item.id] = node; if (item.id2) this.menuRefs[item.id2] = node; }}
                onClick={() => this.itemClickHandler(item.id, item.title, item.link)}
                onMouseOver={() => this.itemMouseoverHandler(item.id) }
                className={item.soon ? 'item--soon' : ''}
          >
            <span className="item--normal__text">{item.title}</span>
            {item.soon ?
              <span className="item--soon__text">скоро</span>
              :
              null
            }
          </span>
          {item.sub ?
            <AnimateHeight
              onAnimationStart={() => {this.animationStartHandler();}}
              onAnimationEnd={() => this.animationEndHandler()}
              className="subListWrapper"
              duration={ 500 }
              height={ height }
            >
              <ul>
                {this.renderMenuList(item.sub)}
              </ul>
            </AnimateHeight>
            : null
          }
        </li>)
    })
  }

  animationStartHandler = () => {
    if (this.interval === undefined) {
      this.interval = setInterval(() => {
        this.updateMarker(this.props.currentItem);
        // console.log('interval', this.interval)
      },20)
    }
  }

  animationEndHandler = () => {
    this.updateMarker(this.props.currentItem);

    if (this.interval !== undefined) {
      setTimeout (() => {
        clearInterval(this.interval)
        this.interval = undefined
        // console.log('afterclean', this.interval)
        this.updateMarker(this.props.currentItem);
      }, 300)
    }

  }

  updateMarker (activeItem) {
    let activeEl = this.menuRefs[activeItem]
    let menuY = this.menu.getBoundingClientRect().y || this.menu.offsetTop
    let x = activeEl.getBoundingClientRect().x || activeEl.getBoundingClientRect().left
    let y = activeEl.getBoundingClientRect().y || activeEl.getBoundingClientRect().top
    let height = activeEl.getBoundingClientRect().height || activeEl.offsetHeight
    this.setState({x, y, height, menuY})
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.currentItem !== this.props.currentItem) {
      this.updateMarker(nextProps.currentItem)
    }
  }

  toggleMenu = () => {
    this.props.onMenuToggle()
    sendEvent('mobile', 'click', 'menu')
  }

  render () {
    const { y, height, hoverY, hoverHeight, markerIsVisible, menuY } = this.state
    const { isOpen } = this.props
    const displayStyle = markerIsVisible ? 'block' : 'none'

    const markerStyles = {
      height: hoverHeight ? hoverHeight : height,
      transform: hoverY ? `translateY(${hoverY - menuY}px)` : `translateY(${y - menuY}px)`,
      display: displayStyle
    }

    let menuListClasses = isOpen ? 'menu__list --open' : 'menu__list'

    return (
      <nav className="menu" ref={this.menuRef} onWheel={e => e.preventDefault()}>
        <div className={isOpen ? "menu__burger --open" : "menu__burger"} onClick={() => this.toggleMenu() }>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className={menuListClasses}>
          <div className="marker" style={markerStyles}></div>
          <ul>
            {this.renderMenuList(this.items)}
          </ul>
          <Share />
        </div>
      </nav>
    )
  }
}

Menu.propTypes = {
  currentItem: PropTypes.number,
  scroll: PropTypes.bool,
  isOpen: PropTypes.bool
}

const mapStateToProps = state => {
  const {menu} = state
  return {
    ...menu
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onMenuClick: (id) => {
      dispatch(selectItem(id, true))
    },
    onMenuToggle: () => {
      dispatch(toggleMenu())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu)


// WEBPACK FOOTER //
// ./src/components/menu/menu.js